import axios from 'axios';

// Determine the API URL based on the environment
const API_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://visitor-management-system-api.onrender.com'
    : 'http://localhost:3001';

console.log('Using API URL:', API_URL); // Add logging to help debug

// Create axios instance with base URL
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
  },
  // Disable withCredentials to avoid CORS preflight issues
  withCredentials: false
});

// Add request interceptor to include auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Safely log the request URL with null checks
    const baseURL = config.baseURL || '';
    const url = config.url || '';
    console.log('Making API request to:', baseURL + url);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle common errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('API Error:', error.response?.status, error.response?.data || error.message); 
    
    // Handle 401 Unauthorized errors
    if (error.response && error.response.status === 401) {
      // Clear token and redirect to login
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
